export default {"en-US": __webpack_public_path__ + "i18n/en-US.15dc69dd.i18next.json"};